import React, { useCallback, useRef, useState } from "react";
import persian from "react-date-object/calendars/persian";
import gregorian from "react-date-object/calendars/gregorian";
import persian_fa from "react-date-object/locales/persian_fa";
import gregorian_en from "react-date-object/locales/gregorian_en";
import DatePicker, { DateObject } from "react-multi-date-picker";
import { TimePickerProps } from "./TimePicker.props";
import TimePicker from "react-multi-date-picker/plugins/time_picker";
import Button from "components/Button";
import "./style.scss";
import { persianToEnglishNumber } from "utils/helpers";

const TimePickerComponent = React.memo<TimePickerProps>(
    ({
        timePickerContainer,
        containerClassName,
        timePickerClassName,
        calendarPosition,
        inputClassName,
        isPersian,
        label,
        title = "",
        placeholder = "",
        setTime,
        ...props
    }) => {
        const [timePicker, setTimePicker] = useState<DateObject>(
            new DateObject({
                locale: persian_fa,
            })
        );

        const CustomTimePickerButton = ({
            onClick,
        }: {
            onClick: () => void;
        }) => (
            <div className="time-picker-button">
                <Button
                    className="solid is-green"
                    handleClick={onClick}
                    btnText="ثبت"
                />
            </div>
        );

        const datePickerRef = useRef<any>(null);

        const handleSetTime = useCallback(() => {
            setTime(timePicker);
            datePickerRef.current?.closeCalendar();
        }, [setTime, timePicker]);

        return (
            <div className={timePickerContainer || ""}>
                {!!label && <span>{label}</span>}
                <DatePicker
                    ref={datePickerRef}
                    disableDayPicker
                    format="HH:mm"
                    containerClassName={containerClassName || ""}
                    className={`timepicker ${timePickerClassName || ""}`}
                    calendarPosition={calendarPosition}
                    inputClass={`rmdp-input ${inputClassName || ""}`}
                    editable={false}
                    onOpenPickNewDate={false}
                    plugins={[
                        <TimePicker position="bottom" hideSeconds />,
                        <CustomTimePickerButton onClick={handleSetTime} />,
                    ]}
                    calendar={isPersian ? persian : gregorian}
                    locale={isPersian ? persian_fa : gregorian_en}
                    value={timePicker}
                    onChange={(timeEvent: DateObject) => {
                        const val =
                            typeof timeEvent === "string"
                                ? persianToEnglishNumber(timeEvent)
                                : timeEvent;
                        setTimePicker(new DateObject(val));
                    }}
                    {...props}
                />
            </div>
        );
    }
);

export default TimePickerComponent;
